import type { Application } from '@src/@types/app';
import { DEFAULT_FILTERS, FILTERS_NAMES, FILTERS_SCHEME, MODES } from '@src/constants/filters';
import { ListKeys } from '@src/constants/microcredits';
import { parse } from '@src/helpers/query';
import { fetchOffers } from '@src/reducers/microcredits';

export const getSidebarBannerData = async (ctx: Application.ReduxNextPageContext) => {
  const {
    store: { dispatch },
    params: { locationRoute },
  } = ctx;

  const query = parse({
    location: locationRoute,
    defaultValues: DEFAULT_FILTERS[MODES.SIDEBAR_BANNER],
    query: '',
    scheme: FILTERS_SCHEME,
  });

  const filterParams = {
    [FILTERS_NAMES.LOCATION]: locationRoute,
  };

  await dispatch(fetchOffers({ key: ListKeys.SIDEBAR_BANNER, query, params: filterParams }));
};
